/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-12 11:28:36
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-22 17:34:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorNavigation/tool.ts
 */
import { errCodesMap } from '@/src/error/code';
import {
  generateCollapseOpen,
  generateCollapseErrorMsgDisplay,
  convertSpecificError,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export const convertDataFromServerToRedux = (res: any) => {
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    contentNavigations,
  } = res;

  const _isNew = !uuid;

  const ids = contentNavigations.map((v) => v.uuid).filter((v) => v);

  const collapseOpen = generateCollapseOpen(ids);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(ids, !_isNew);

  return {
    contentNavigations,
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    modifiedDate,
    createdDate,
    uuid,
  };
};

export const convertDataFromReduxToServer = (res: any) => {
  const contentNavigations = res.contentNavigations.map((v) => {
    if (v.isNew) {
      return {
        ...v,
        uuid: null,
      };
    } else {
      return v;
    }
  });

  return {
    ...res,
    contentNavigations,
  };
};

export const navigationValidation = (navigation: any) => {
  const { title, linkModule, menuItems } = navigation;
  const specificError = {};
  if (!title) {
    specificError['titleError'] = [errCodesMap[999993]];
  }
  if (!linkModule.linkType) {
    specificError['linkModuleError'] = [errCodesMap[104337]];
  }
  menuItems.map((item) => {
    specificError[`${item.uuid}_titleError`] = [];
    specificError[`${item.uuid}_linkError`] = [];
    if (!item.title) {
      specificError[`${item.uuid}_titleError`].push(errCodesMap[999993]);
    }
    if (!item?.linkModule?.linkType) {
      specificError[`${item.uuid}_linkError`].push(errCodesMap[104337]);
    }
  });
  return {
    hasError: convertSpecificError(specificError).length > 0,
    specificError,
    generalError: [],
  };
};
